import AwardsCarousel24 from "./awardsCarousel24";

export default AwardsCarousel24;
